import * as ts from "../common/Translator";
import {nextId, registerOnWindowResize} from "../common/NamaCommon";
import {_calcWindowDimensions, updateCheckBoxes} from "./search/SearcherWindow";
import {attachNextAndPreviousFocus} from "../routing/EditPresenter";
import {isMobileDevice} from "../common/GUIUtilities";
import {deleteSelectedRows} from "../grid/GridEventsController";
import NamaKendoWindowTemplate from "../compiled-templates/NamaKendoWindowTemplate";

export class NamaWindowBtnData {
    /**
     *
     * @param {string} btnTitle
     * @param {function} btnAction
     */
    constructor(btnTitle, btnAction) {
        let that = this;
        that.btnTitle = btnTitle;
        that.btnAction = btnAction;
    }
}

export class NamaKendoWindow {

    /**
     *
     * @param {string} title
     * @param {NamaWindowBtnData} okBtnData
     * @param {NamaWindowBtnData} cancelBtnData
     */
    constructor(title, okBtnData, cancelBtnData, width, withoutBtns, fullScreen, inQuestionListWidget) {
        let that = this;
        that.title = title;
        that.okBtnData = okBtnData;
        that.cancelBtnData = cancelBtnData;
        that.elementId = nextId();
        that.inQuestionListWidget = inQuestionListWidget;
        let window = $(NamaKendoWindowTemplate({elementId: that.elementId, translateId: ts.translateId}));
        if (!that.inQuestionListWidget) {
            window.find("#selectAll").remove();
            window.find("#deleteAll").remove();
            window.find("#deleteSelected").remove();
        }
        if (!okBtnData)
            window.find("#ok").remove();
        if (!cancelBtnData)
            window.find("#cancel").remove();
        if (withoutBtns || !window.find(".searcherWindowBtns").children().length)
            window.find(".searcherWindowBtns").remove();
        that.window = window;
        that.content = window.find("#grid");
        if (isMobileDevice())
            width = "100%";
        that.width = width || "75%";
        that.fullScreen = fullScreen;
    }

    showWindow(callBack, notModal) {
        let that = this;
        if (that.isOpen())
            return;
        that.window.find("#ok").click((e) => {
            e.preventDefault();
            that.okBtnData.btnAction();
        });
        that.window.find("#cancel").click((e) => {
            e.preventDefault();
            that.closeWindow(e);
        });
        that.window.find("#selectAll").click((e) => {
            e.preventDefault();
            updateCheckBoxes(true, that.window.find("#grid"));
        });
        that.window.find("#deleteAll").click((e) => {
            e.preventDefault();
            let grid = that.window.find("#grid");
            updateCheckBoxes(true, grid);
            deleteSelectedRows(that.gridWidget, that.gridWidget._kendoGrid());
        });
        that.window.find("#deleteSelected").click((e) => {
            e.preventDefault();
            deleteSelectedRows(that.gridWidget, that.gridWidget._kendoGrid());
        });
        if (that.infoForField)
            that.window.attr("infoForField", that.infoForField);
        let modal_ = true;
        if (notModal)
            modal_ = false;
        let kWindowDim = _calcWindowDimensions();
        let minWidth = kWindowDim.width / 2;
        if (that.width.contains("%")) {
            let widthInPx = parseInt(that.width) * $("body").width() / 100;
            minWidth = widthInPx < minWidth ? that.width : minWidth;
        } else if (that.width.contains("px")) {
            minWidth = parseInt(that.width) < minWidth ? that.width : minWidth;
        }
        if (isMobileDevice()) {
            that.width = "90%";
            that.height = "80%";
            minWidth = "90%";
        }

        if (!isMobileDevice() && !that.height)
            that.height = _calcWindowDimensions().height / 2;
        if (that.doNotSetHeightWidth) {
            minWidth = that.width = that.height = undefined;
        }
        that.kendowWindow = that.window.kendoWindow({
            minWidth: minWidth,
            resizable: true,
            resize: (e) => {
                that.calcGridHeight();
            },
            width: that.width,
            height: that.height,
            scrollable: true,
            title: ts.translateId(that.title),
            visible: false,
            modal: modal_,
            actions: [
                "Maximize",
                "Close"
            ],
            close: function (e) {
                that.closeWindow(e);
            }
        }).data("kendoWindow");
        if (that.fullScreen)
            that.kendowWindow.open().maximize();
        else
            that.kendowWindow.open().center();
        setTimeout(() => that.content.find(":input:enabled:visible:first").focus(), 500);
        attachNextAndPreviousFocus(that.content);
        setTimeout(() => {
            if (that.doCallBackFirstly && callBack)
                callBack();
            that.calcGridHeight();
            registerOnWindowResize(that.windowRootElement()[0], (e) => {
                that.calcGridHeight();
            });
            if (!that.doCallBackFirstly && callBack)
                callBack();
        }, that.callBackWaitTime ? that.callBackWaitTime : 10);
    }

    windowRootElement() {
        return $("#window" + this.elementId);
    }

    calcGridHeight() {
        let that = this;
        let window = that.windowRootElement();
        let windowHeight = window.height();
        let footerHeight = window.find(".searcherWindowBtns").outerHeight();
        let height = windowHeight - footerHeight;
        if (that.extraDeductedHeight)
            height = height - that.extraDeductedHeight;
        else
            height = height - 4;
        let grid = window.find("#grid");
        grid.height(height);
        if (grid.find("#splitter").length) {
            let pageHeaderHeight = grid.find(".page-top-header").outerHeight();
            grid.find("#splitter").height(height - pageHeaderHeight);
            grid.find("#splitter").addClass("windowInnerSplitter");
        }
    }

    addDataWidget(widget) {
        let that = this;
        that.content.append(widget);
    }

    closeWindow(e) {
        let that = this;
        if (that.cancelBtnData && that.cancelBtnData.btnAction)
            that.cancelBtnData.btnAction(e);
        if (that.window.data("kendoWindow"))
            that.window.data("kendoWindow").destroy();
    }

    refresh() {
        this.window.data("kendoWindow").refresh();
    }

    isOpen() {
        let wnd = this.window.data("kendoWindow");
        return wnd ? wnd.element.is(":visible") : false;
    }

    rootElement() {
        return this.window;
    }

    /**
     *
     * @param {NamaWindowBtnData} button
     */
    addButton(button) {
        let id = "searcherWindowBtn-" + button.btnTitle;
        let matchedIds = this.window.find(".searcherWindowBtns").find(`#${id}`);
        if (matchedIds.length)
            id += `${matchedIds.length}`;
        this.window.find(".searcherWindowBtns").append(`<button id='${id}' class=" k-button rounded-sm">${ts.translateId(button.btnTitle)}</button>`);
        this.window.find(".searcherWindowBtns").find(`#${id}`).on('click', () => button.btnAction());
    }
}